/* La Pepa · Price tiers (sections/lp-price-tiers.liquid)
 * Desktop: Hover bzw. Tastaturfokus spreizt den Fächer (reines CSS). Touch: erster Tipp auf Bühne oder Namen spreizt
 * (Klasse is-open), zweiter öffnet das Produkt; Tipp daneben oder Escape schließt. Beim ersten Einblenden liegen die
 * Produkte gestapelt und fächern gestaffelt auf (nur wenn die Section beim Laden unterhalb des Bildschirms liegt).
 */
class LpPriceTiers extends HTMLElement {
  #abort;
  #io;

  connectedCallback() {
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    const touch = matchMedia('(hover: none)');

    this.addEventListener('click', (event) => {
      const tile = event.target.closest('.lp-tiers__tile');
      if (!tile || !event.target.closest('.lp-tiers__stage, .lp-tiers__foot')) return;
      const link = event.target.closest('a');
      const open = tile.classList.contains('is-open');
      if (link && (open || !touch.matches)) return; // gespreizt bzw. Desktop: Link öffnet das Produkt
      event.preventDefault();
      if (link || !open) this.open(tile);
      else tile.classList.remove('is-open');
    }, { signal });
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.lp-tiers__tile')) this.open(null);
    }, { signal });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.open(null);
    }, { signal });

    // Theme-Editor: gewählte Kachel aufgespreizt zeigen
    this.addEventListener('shopify:block:select', (event) => {
      const tile = event.target.closest?.('.lp-tiers__tile');
      if (!tile) return;
      this.open(tile);
      tile.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }, { signal });
    this.addEventListener('shopify:block:deselect', () => this.open(null), { signal });

    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const row = this.querySelector('.lp-tiers__row');
    if (reduce || !row || !('IntersectionObserver' in window) || this.getBoundingClientRect().top < window.innerHeight) return;
    this.classList.add('is-armed');
    this.#io = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      this.#io.disconnect();
      this.classList.add('is-entering');
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-in')));
      setTimeout(() => this.classList.remove('is-entering'), 1800);
    }, { threshold: 0.25 });
    this.#io.observe(row);
  }

  disconnectedCallback() {
    this.#abort?.abort();
    this.#io?.disconnect();
  }

  open(tile) {
    this.querySelectorAll('.lp-tiers__tile').forEach((t) => t.classList.toggle('is-open', t === tile));
  }
}

if (!customElements.get('lp-price-tiers')) customElements.define('lp-price-tiers', LpPriceTiers);
